import React, { useEffect, useState } from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Card, Col, Container, Dropdown, Nav, Navbar, Row, Spinner } from 'react-bootstrap';
import logo1 from '../Assets/logonew.png'
import "../Admin/AdminMaster/AdminBilling.css";
import './Master.css'
import { Button, Form, Modal, Table } from 'react-bootstrap'
import { CustomerFindAll, EmployeeAdd, EmployeeDelete, EmployeeFindAll, EmployeeUpdate, OrderAllotmentAdd, OrderAllotmentDelete, OrderAllotmentFindAll, OrderAllotmentOuterFindAll, OrderAllotmentUpdate, ProductFindAll, ProductFindAllOrderAllotment } from '../Admin/API/Api'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Autocomplete, Paper, TextField } from '@mui/material'
import AdminNavBar from './AdminNavBar';
import NavLogo from './NavLogo';
import { MDBDataTable } from 'mdbreact';

const OrderAllotment1 = () => {

    const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;
    const Name = userdata ? userdata.branch_name : '';
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  const [selectedCustomerName, setSelectedCustomerName] = useState('');
  const [isEditing, setisEditing] = useState(false)
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [orderId, setOrderId] = useState()
  const [id, setId] = useState()
  const [product_master, setProduct_master] = useState([]);
  const [employee_master, setEmployee_master] = useState([]);
  const [customer_master, setCustomer_master] = useState([]);
  const [productId, setProductId] = useState();
  const [employeeId, setEmployeeId] = useState('');
  const [customerId, setCustomerId] = useState();
  const [quantity, setQuantity] = useState();
  const [amount, setAmount] = useState();
  const [date, setDate] = useState();

 
  const handleShow = (item) => {
    setSelectedCustomerName(item.customer_name);
    setOrderId(item.order_id);
    setId(item.id);
    setCustomerId(item.customer_id);
    setQuantity(item.quntity);
    setAmount(item.amount);
    setShow(true);
  };
  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
  const [show1, setShow1] = useState(false)
  ;
  const handleClose1 = () => setShow1(false);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleShow1 = (item) => {
    setItemToDelete(item);
    setShow1(true);
  };
  //  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setOrderId('');
    setId('');
    setProductId('');
    setQuantity('');
    setAmount('');
  };

  const setEditDataFun = (item) => {
    setProductId(item.product_id);
    setCustomerId(item.customer_id);
    setQuantity(item.quntity);
    setAmount(item.rate);
    setOrderId(item.order_id);
    setId(item.id);
    setisEditing(true)
  }
  const handleClose = () => {
    setShow(false);
};

let isOrderFetched = false
  useEffect(() => {
    if (isOrderFetched) return
    Getdata();
    GetOrderdata();
    isOrderFetched = true
  }, [customerId, employeeId])

  let isOrder1Fetched = false
  useEffect(() => {
      if (isOrder1Fetched) return
      Getdata();
      isOrder1Fetched = true
  }, []);


  const Getdata = (e) => {

    if (!customerId) {
      return;
    }
    axios
      .get(`${OrderAllotmentFindAll}/${customerId}/${branchId}`)
      .then((res) => {
        if (res.data !== null) {
          setData(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  const GetOrderdata = (e) => {

    if (!employeeId) {
      // employeeId is not set, handle accordingly
      return;
    }
    setOrderData([]);

    axios
      .get(`${OrderAllotmentOuterFindAll}/${employeeId}/${branchId}`)
      .then((res) => {
        if (res.data.length === 0) {
          console.log("in else block ");
          toast.warn("Customer Not Allocated...")
        }
        else if (res.data !== null) {
          console.log("in if block " ,res.data);
          setOrderData(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  const savedata = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!quantity || !productId || !amount) {
      alert("Please fill in all fields");
      setLoading(false);
      return;
      
    }
  
    const obj = {
      customer_id: customerId,
      product_id: productId,
      quntity: quantity,
      amount: amount,
      branch_id: branchId
    };
  
    axios
      .post(OrderAllotmentAdd, obj)
      .then((res) => {
        console.log("res", res.data)
        if (res.data === "SAVED") {
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata();
          GetOrderdata();
          setProductId('');
          setQuantity('');
          setAmount('');
          setLoading(false);
        } else if (res.data === 'ALREADYEXIST') {
          toast.info('Data already exists.', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
        console.error(err);
      });
  };
  
  const updateOrderAllotment = () => {
    setLoading(true);
    if (!selectedCustomerName || !productId || !quantity || !amount) {
      alert("Please fill in all the fields");
      setLoading(false);
      return;
    }
  
    const formData = {
      product_id: productId,
      quntity: quantity,
      amount: amount
    };
  
    axios
      .put(`${OrderAllotmentUpdate}${id}`, formData)
      .then((res) => {
        console.log("order update res....", res.data)
        if (res.data === "UPDATE") {
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
         
          Getdata();
          GetOrderdata();
          setProductId('');
          setQuantity('');
          setAmount('');
          setLoading(false);
        } else if (res.data === 'ALREADYEXIST') {
          toast.info('Data already exists.', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error while updating Employee:", err);
        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
      });
  };

  

  //delete data
  const onDelete = (item) => {
    console.log("Deleting item:", item);
    axios
      .delete(`${OrderAllotmentDelete}${item.id}`)
      .then((res) => {
        console.log("Delete response:", res.data);
        if (res.data === "DELETE") {
          toast.success("Data Deleted Succesfuly!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        handleClose1(false)
        Getdata();
        GetOrderdata();
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        console.log("Error deleting item:", err);
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  //CustomerData Logic
  const Customerdata = (e) => {
    axios
      .get(`${CustomerFindAll}/${branchId}`)
      .then((res) => {
        if (res.data !== null) {
          setCustomer_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };


  //Product Logic
  const Productdata = (e) => {
 
    axios
      .get(`${ProductFindAllOrderAllotment}/${branchId}`)
      .then((res) => {
        if (res.data !== null) {
          setProduct_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  //Employeedata Logic
  const Employeedata = (e) => {
    axios
      .get(`${EmployeeFindAll}/${branchId}`)
      .then((res) => {
        if (res.data !== null) {
          setEmployee_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };

  useEffect(() => {
    if (isEditing === false) {
      Getdata();
      GetOrderdata();
      Productdata();
      Customerdata();
      Employeedata();

    }
  }, [isEditing]);

  const columns = [
    {
        label:  (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'),
        field: 'srNo',
        sort: 'asc',
    },
    {
        label: (selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'),
        field: 'customer',
        sort: 'asc',
    },
    {
        label: (selectedLanguage === 'Marathi' ? 'ॲड' : 'Add'),
        field: 'add',
        sort: 'asc',
    },
    {
        label: (selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'),
        field: 'product',
        sort: 'asc',
    }
];

// Map orderData to rows for MDBDataTable
const rows = orderData.map((item, index) => ({
    srNo: index + 1,
    customer: item.customer_name,
    add: (
        <button className='m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
            onClick={() => handleShow(item)}
        >
            <i style={{ color: "rgb(255, 93, 0)" }} className="fa-solid fa-plus"></i>
        </button>
    ),
    product: item.total
}));


  return (
    <div>
    <AdminNavBar />
       <section className="home-section">
   
       <NavLogo />

    <Row className="m-0 p-0 pt-5 px-md-4 px-2">
        <Col className=' rounded text-center pt-2 ps-3'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h5>
{selectedLanguage === 'Marathi' ? 'ऑर्डर वाटप' : 'ORDER ALLOTMENT'}
          </h5>
        </Col>
      </Row>

{/* ========================== Customer Master =========================== */}

<Row className="m-0  py-3 px-2 mx-md-3  rounded">
    <Col className="m-0 p-0  px-3 rounded" style={{background:"white"}} >

          <Row >
            <Col className='m-0 py-3' >

            <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'कर्मचारी निवडा' : 'Select Employee'}:</h6></Form.Label><br />
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                size="small"
                options={employee_master}
                getOptionLabel={(option) => option.name}
                value={employee_master.find((item) => item.employee_id === employeeId) || null}
                onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
                renderInput={(params) => <TextField {...params} style={{ width: '280px'}} label={selectedLanguage === 'Marathi' ? 'कर्मचारी निवडा' : 'Select Employee'} />}
              />
            </Col>
          </Row>
            </Col>
          </Row>


          {/* <Row className="m-0  pt-2 px-2 mx-md-3  rounded">
    <Col className="m-0 p-0  px-3 rounded" style={{background:"white"}} >
    
          <div style={{ overflowY: 'auto' }}>
            <div style={{ overflowX: 'auto' }}>
            
              <Table striped bordered hover size="sm" className=' my-4' style={{ textAlign: "center" }}>
                <thead >
                  <tr >
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Sr.No</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Customer</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Add</th>
                    <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Product</th>
                  </tr>
                </thead>
                <tbody>
                  {orderData.map((item, index) => {
                    return (
                      <tr className='border' >
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td style={{ textAlign: "center" }}>{item.customer_name}</td>
                        <td style={{ textAlign: "center" }}>
                          <button className=' m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
                            onClick={() => handleShow(item)}
                          ><i style={{ color: "rgb(255, 93, 0)" }} class="fa-solid fa-plus"></i></button></td>
                        <td style={{ textAlign: "center" }}>{item.total}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
          </div>
          </Col>
          </Row> */}


          <Row className="m-0  pt-2 px-2 mx-md-3  rounded">
    <Col className="m-0 p-0 py-3 px-3 rounded" style={{background:"white"}} >
                <MDBDataTable
                    striped
                    bordered 
                    className='custom-datatable'
                    hover
                    data={{ columns, rows }}
                />
            </Col>
            </Row>

        {/* ========================== Modal ============= */}
        <Modal className='shadow rounded' size='xl' show={show} onHide={handleClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor:"rgb(214, 234, 248)", color: "black" }} >
            <Modal.Title >

              <p style={{ fontSize: "15px" }} className='text-center mt-2'><b>{selectedLanguage === 'Marathi' ? 'ऑर्डर वाटप' : 'Order Allotment'}</b></p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form encType="multipart/form-data">
              <Row className='m-0 p-0'>
                <Col sm={12} md={3} className='mt-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="text"
                    readOnly
                    value={selectedCustomerName}
                  />
                </Col>

                <Col sm={12} md={3} className='mt-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'}:</b></h6></Form.Label>
                  {isEditing ? (
                  <TextField
                  style={{ width: '100%' }}
                    size="small"
                    label="Select Product"
                    value={product_master.find((item) => item.product_id === productId)?.product_name || ''}
                    readOnly
                  />
                ) : (
                  <Autocomplete
                    disablePortal
                    size="small"
                    style={{ width: '100%' }}
                    id="combo-box-demo"
                    options={product_master}
                    getOptionLabel={(option) => option.product_name}
                    value={product_master.find((item) => item.product_id === productId) || null}
                    onChange={(e, newValue) => setProductId(newValue ? newValue.product_id : '')}
                    renderInput={(params) => <TextField {...params} label="Select Product" />}
                  />
                )}
                </Col>
                
                <Col sm={12} md={3} className='mt-3 '>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Quantity"
                    pattern="[0-9]"
                    required
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                  />
                </Col>

                <Col sm={12} md={3} className='mt-3 mb-3'>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'प्रति मात्रा किंमत' : 'Price per quantity'}:</b></h6></Form.Label>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    placeholder="Enter Amount"
                    pattern="[0-9]"
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Col>

              </Row>
              <Row className='mt-2 mb-3'>
                <Col style={{ display: "flex", justifyContent: "center" }}>
                  {isEditing === false ? (
                    <Button
                      style={{
                        border: "2px solid rgb(47, 79, 79)",
                        backgroundColor:
                          "rgb(47, 79, 79)",
                          color:"white",
                        borderRadius: "15px",
                        fontSize:"17px"
                      }}
                      className="py-2 mb-3 px-3 mx-2 shadow "
                      type="submit"
                      onClick={savedata}
                      disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                     {selectedLanguage === 'Marathi' ? 'जतन करा' : 'Save'}</div>}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        border: "2px solid rgb(47, 79, 79)",
                        backgroundColor: "rgb(47, 79, 79)",
                        color:"white",
                        borderRadius: "15px ",
                        fontSize:"17px"
                      }}
                      className="py-2 px-3 mb-3 mx-2 shadow "
                      type="submit"
                      onClick={updateOrderAllotment}
                      disabled={loading}
                    >{loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>
                      {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'} </div>}
                    </Button>
                  )}
                </Col>
              </Row>
            </Form>

            <div style={{ overflowY: 'auto' }}>
              <div style={{ overflowX: 'auto' }}>
                <Table striped bordered hover size="sm" className='shadow mt-2' style={{ textAlign: "center" }}>
                  <thead >
                    <tr >
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'ग्राहकाचे नाव' : 'Customer Name'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'उत्पादन' : 'Product'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'संख्या' : 'Quantity'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'रक्कम' : 'Amount'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'सुधारणे' : 'Edit'}</th>
                      <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>{selectedLanguage === 'Marathi' ? 'हटवा' : 'Delete'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => {
                      return (
                        <tr className='border' >
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>{item.customer_name}</td>
                          <td style={{ textAlign: "center" }}>{item.product_name}</td>
                          <td style={{ textAlign: "center" }}>{item.quntity}</td>
                          <td style={{ textAlign: "center" }}>{item.rate}</td>
                          <td style={{ textAlign: "center" }}>
                            <button className=' m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
                              onClick={() => setEditDataFun(item)}
                            ><i class="fa-solid fa-pen-to-square"></i></button></td>

                          <td style={{ textAlign: "center" }}>
                            <button className=' m-1' style={{ color: "red", border: "0px", backgroundColor: "transparent" }}

                              onClick={() => handleShow1(item)}
                            ><i className="fa-solid fa-trash"></i></button></td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            </div>

          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor:"rgb(214, 234, 248)" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleClose}>
              Cancel
            </Button>

          </Modal.Footer>
        </Modal>


        {/* ============= Delete Modal ========= */}

        <Modal show={show1} onHide={handleClose1}>
          <Modal.Header style={{ backgroundColor:"rgb(214, 234, 248)", color: "black" }} >
            <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>{selectedLanguage === 'Marathi' ? 'पुष्टीकरण हटवा' : 'Delete Confirmation'}</Modal.Title>
          </Modal.Header>
          <Modal.Body >{selectedLanguage === 'Marathi' ? 'तुमची खात्री आहे की तुम्ही हा आयटम हटवू इच्छिता?' : 'Are you sure you want to delete this item?'}</Modal.Body>
          <p className='text-end'>
            <Button className='mx-2' style={{ color: "black", backgroundColor: "white", border: "2px solid darkslategray", borderRadius: "15px" }} onClick={handleClose1}>
            {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
            </Button>
            <Button style={{ border: "1px solid darkslategray", backgroundColor: "darkslategray", borderRadius: "15px" }} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
            {selectedLanguage === 'Marathi' ? 'हटवा' : ' Delete'} 
            </Button></p>
        </Modal>

</section>
    </div>
  )
}

export default OrderAllotment1 
